var _defs, _ellipse, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _rect2, _rect3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinityStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 92.301,
    height: 192.124,
    viewBox: "0 0 92.301 192.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.08,
    y1: 0.493,
    x2: 1.006,
    y2: 0.513,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebdc2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    stopColor: "#bc8e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#ebdc2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#e7d62b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dfc825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#d0b01a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc8e0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.031,
    y1: 0.475,
    x2: 1.028,
    y2: 0.491,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ebdc2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#e7d62b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dfc825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#d0b01a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#bc8e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc8e0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.008,
    y1: 2.09,
    x2: 1.254,
    y2: -0.34,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.268,
    y1: 0.341,
    x2: 0.5,
    y2: 1.755,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#ff722e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#ff702e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.188,
    y1: 1.55,
    x2: 0.495,
    y2: 0.119,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#373b45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8093b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.125,
    y1: 0.208,
    x2: 1.108,
    y2: 1.516,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#373b45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#485366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -14.135,
    y1: -0.232,
    x2: -12.515,
    y2: 1.862,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.408,
    y1: -0.06,
    x2: 0.21,
    y2: 0.854,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -23.748,
    y1: 0.037,
    x2: -23.883,
    y2: 0.865,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.215,
    y1: -4.007,
    x2: -0.241,
    y2: 2.812,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#4b505e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2b0c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.271,
    y1: -0.269,
    x2: 0.353,
    y2: 1,
    xlinkHref: "#linear-gradient-4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12359",
    "data-name": "Group 12359",
    transform: "translate(-148.35 -9.283)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 34,
    cy: 3,
    rx: 34,
    ry: 3,
    transform: "translate(157.184 195.407)",
    fill: "#707070",
    opacity: 0.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12356",
    "data-name": "Group 12356",
    transform: "translate(148.35 36.46)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12974",
    "data-name": "Path 12974",
    d: "M234.628,354.722q-.264,1.229-.6,2.435a41.457,41.457,0,0,1-1.746,4.975,42.862,42.862,0,0,1-3.819,7.065,44.422,44.422,0,0,1-4.212,5.378A45.346,45.346,0,0,1,206.2,386.662q-1.938.7-3.954,1.215a42.57,42.57,0,0,1-31.324-4.08c-.27-.152-.54-.308-.805-.466q-1.359-.8-2.639-1.693c-.266-.186-.53-.372-.788-.563-.042-.03-.084-.063-.126-.093A44.736,44.736,0,0,1,152.453,363.4c-.1-.216-.193-.432-.289-.651a46.14,46.14,0,0,1-2.039-5.664c-.069-.231-.134-.461-.2-.694a45.44,45.44,0,0,1-1.265-6.508,42.736,42.736,0,0,1-.313-5.46,40.853,40.853,0,0,1,.845-8.074,38.526,38.526,0,0,1,2.86-8.567,44.868,44.868,0,0,1,11.853-15.105v0a55.816,55.816,0,0,1,5.666-4.188,49.539,49.539,0,0,1,7.55-4.068h.042c.117-.01.234-.019.35-.026a96.417,96.417,0,0,1,36.338,4.478q1.129.363,2.186.735s.006,0,.009.005c.253.086.506.175.752.263.038.015.074.026.113.042q.882.681,1.727,1.4c.1.08.191.163.285.246a48.936,48.936,0,0,1,9.535,11.028v0a47.06,47.06,0,0,1,2.4,4.272c.406.819.788,1.65,1.14,2.488q.359.835.676,1.682a44.066,44.066,0,0,1,2.439,9.571,40.8,40.8,0,0,1,.384,4.855,40.255,40.255,0,0,1-.876,9.269Z",
    transform: "translate(-148.35 -227.675)",
    fill: "#e9f0fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12975",
    "data-name": "Path 12975",
    d: "M268.657,311.383a1.034,1.034,0,0,1-.332.59,5.869,5.869,0,0,1-2.92,1.107l-.025,0a32.879,32.879,0,0,1-4.924.4l-.4.008a91.576,91.576,0,0,1-13.681-1.065c-2.158-.314-4.235-.684-6.186-1.09h0c-6.423-1.33-11.488-3.049-13.678-4.621-.1-.07-.186-.141-.272-.208a2.173,2.173,0,0,1-.9-1.224.878.878,0,0,1,0-.269.994.994,0,0,1,.06-.213.921.921,0,0,1,.116-.2,1.873,1.873,0,0,1,.652-.536l.232-.121a.115.115,0,0,0,.027-.012,6.919,6.919,0,0,1,1.014-.357c3.584-.985,11.341-.9,20.185.4,7.19,1.055,13.463,2.676,17.247,4.309a.012.012,0,0,1,.009.005c.389.167.75.336,1.083.5,0,0,.006,0,.009.005,1.5.751,2.435,1.492,2.651,2.169a.945.945,0,0,1,.041.424Z",
    transform: "translate(-198.263 -226.858)",
    fill: "#aeb7c5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12976",
    "data-name": "Path 12976",
    d: "M177.536,335.177a80.355,80.355,0,0,0-11.785,15.683,14.448,14.448,0,0,1-6.863-7.385,44.87,44.87,0,0,1,11.853-15.1,12.612,12.612,0,0,0,6.8,6.807Z",
    transform: "translate(-155.184 -243.371)",
    fill: "#aeb7c5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12977",
    "data-name": "Path 12977",
    d: "M367.338,374.574a14.4,14.4,0,0,1-8.666,4.786,80.059,80.059,0,0,0-6.422-18.534,12.718,12.718,0,0,0,4.9-1.457,12.573,12.573,0,0,0,3.527-2.809,47.229,47.229,0,0,1,2.4,4.272c.406.819.788,1.65,1.14,2.488q.359.835.676,1.682a44.064,44.064,0,0,1,2.439,9.571Z",
    transform: "translate(-280.569 -261.652)",
    fill: "#aeb7c5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 10.216,
    height: 14.303,
    rx: 5.108,
    transform: "translate(38.043 104.89) rotate(-81.668)",
    fill: "#2eb3bd",
    opacity: 0.61,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 31.61,
    height: 3.597,
    transform: "translate(38.692 136.923) rotate(-81.423)",
    fill: "#2eb3bd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12978",
    "data-name": "Path 12978",
    d: "M234.028,431.412a41.516,41.516,0,0,1-1.746,4.975,71.28,71.28,0,0,1-12.043,4.551l-.1.027a74.455,74.455,0,0,1-36.39.538,84.448,84.448,0,0,1-28.988-12.756c-2.377-1.629-4.416-3.211-6.1-4.611a42.735,42.735,0,0,1-.313-5.46c1.006.878,2.172,1.854,3.49,2.886a84.83,84.83,0,0,0,28.436,14.706c2.439.7,4.763,1.227,6.91,1.64q1.868.355,3.548.593a69.647,69.647,0,0,0,9.761.776,75.324,75.324,0,0,0,21.459-3.174c2.132-.632,4.35-1.388,6.627-2.288,2.112-.835,3.944-1.671,5.446-2.4Z",
    transform: "translate(-148.35 -301.931)",
    fill: "#2eb3bd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12979",
    "data-name": "Path 12979",
    d: "M173.39,480.941q-1.359-.8-2.639-1.693c-.266-.186-.53-.372-.788-.563a40.6,40.6,0,0,0,1.488-5.675,4.232,4.232,0,0,0-.277-2.794,4.149,4.149,0,0,0-1.408-1.473,3.674,3.674,0,0,0-.8-.342,78.269,78.269,0,0,1-13.243-7.394c-.1-.216-.193-.432-.289-.651a46.123,46.123,0,0,1-2.039-5.664c.089.071.184.148.277.22a87.432,87.432,0,0,0,18.834,11.231,4.61,4.61,0,0,1,.89.383,5.044,5.044,0,0,1,2.5,5.481,41.283,41.283,0,0,1-2.51,8.935Z",
    transform: "translate(-151.625 -325.284)",
    fill: "#2eb3bd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12980",
    "data-name": "Path 12980",
    d: "M327.625,489.157a44.452,44.452,0,0,1-4.212,5.378,78.467,78.467,0,0,1-14.11,3.02,3.581,3.581,0,0,0-.864.1,4.178,4.178,0,0,0-1.775,1,4.251,4.251,0,0,0-1.071,2.6,41.072,41.072,0,0,0-.232,5.37q-1.937.7-3.954,1.215a41.148,41.148,0,0,1,.218-8.836,5.045,5.045,0,0,1,3.979-4.523,4.621,4.621,0,0,1,.963-.106,87.568,87.568,0,0,0,21.058-5.214Z",
    transform: "translate(-247.513 -347.633)",
    fill: "#2eb3bd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12981",
    "data-name": "Path 12981",
    d: "M263.769,308.05a31.656,31.656,0,0,0-16.106,1.646,17.262,17.262,0,0,1-7.476,1.639h0a18.073,18.073,0,0,1-4.618-.833c-2.883-.78-7.049-2.293-9.061-3.788-.1-.07-.186-.141-.272-.208a2.319,2.319,0,0,1-.9-1.224.874.874,0,0,1,0-.269,1,1,0,0,1,.06-.214,1.083,1.083,0,0,1,.116-.2,2.07,2.07,0,0,1,.652-.536c.075-.04.153-.079.232-.121a.114.114,0,0,0,.027-.012c.211-.108.434-.22.663-.331.117-.01.234-.02.35-.026,3.584-.985,11.341-.9,20.185.4,7.19,1.055,13.463,2.676,17.247,4.309-.348-.085-.71-.163-1.094-.228Z",
    transform: "translate(-198.263 -226.858)",
    fill: "#232952",
    opacity: 0.24,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12982",
    "data-name": "Path 12982",
    d: "M313.552,367.9q-.264,1.229-.6,2.435a41.454,41.454,0,0,1-1.746,4.975,42.867,42.867,0,0,1-3.819,7.065,44.433,44.433,0,0,1-4.212,5.378,45.345,45.345,0,0,1-18.052,12.086q-1.938.7-3.954,1.215a42.406,42.406,0,0,1-11.106,1.332,61.151,61.151,0,0,0,9.091-3.849c5.544-2.89,12.375-6.454,17.452-14.2a33.723,33.723,0,0,0,2.458-4.446,35.349,35.349,0,0,0,1.816-4.863,50.922,50.922,0,0,0,1.258-5.6,47.253,47.253,0,0,0-1.243-20.862,36.438,36.438,0,0,0-8.782-15.667,33.693,33.693,0,0,0-7.068-5.5c.72.025,6.533.22,7.549.03a13.719,13.719,0,0,0,1.8-.345l.025,0a14.617,14.617,0,0,0,2.92-1.107,2.393,2.393,0,0,0,.291-1.014,1.362,1.362,0,0,0-.059-.469,49.07,49.07,0,0,1,9.82,11.274v0a47.113,47.113,0,0,1,2.4,4.271c.406.819.788,1.65,1.14,2.489q.359.835.676,1.682a44.044,44.044,0,0,1,2.439,9.571,40.663,40.663,0,0,1,.384,4.855,40.255,40.255,0,0,1-.875,9.269Z",
    transform: "translate(-227.274 -240.85)",
    fill: "#232952",
    opacity: 0.24,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12983",
    "data-name": "Path 12983",
    d: "M166.562,388.951a44.736,44.736,0,0,1-14.109-17.585c-.1-.216-.193-.432-.289-.651a46.13,46.13,0,0,1-2.039-5.664c-.069-.231-.134-.461-.2-.693a45.442,45.442,0,0,1-1.265-6.508,42.737,42.737,0,0,1-.313-5.46,40.854,40.854,0,0,1,.845-8.074,38.546,38.546,0,0,1,2.86-8.567,44.869,44.869,0,0,1,11.853-15.105v0a55.824,55.824,0,0,1,5.666-4.188c-1.028,1.152-2.16,2.462-3.354,3.919-3.612,4.4-7.685,9.365-10.52,15.078a49.38,49.38,0,0,0-4.7,21.128c.323,15.439,9.843,26.857,15.558,32.375Z",
    transform: "translate(-148.35 -235.643)",
    fill: "#fff",
    opacity: 0.49,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12984",
    "data-name": "Path 12984",
    d: "M324.112,322.723a2.763,2.763,0,0,1-1.69,1.316.057.057,0,0,0-.023.009,20.428,20.428,0,0,1-3.364.722,24.6,24.6,0,0,1-8.167-.06h-.007l-.02,0a47.53,47.53,0,0,0,4.937-.635c3.556-.646,5.351-.988,6.027-2.11a2.718,2.718,0,0,0,.369-1.422c0-.045,0-.094,0-.144.038.015.074.027.113.042q.883.681,1.727,1.4c.1.08.191.163.285.246a2.085,2.085,0,0,1-.185.646Z",
    transform: "translate(-253.718 -238.199)",
    fill: "#fff",
    opacity: 0.49,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12985",
    "data-name": "Path 12985",
    d: "M269.808,168.481a4.6,4.6,0,0,1-2.321.507,56.941,56.941,0,0,1-22.759-3.394q-.658-.241-1.289-.492a56.7,56.7,0,0,1-12.592-6.963c-.561-.414-1.092-.816-1.583-1.2a4.572,4.572,0,0,1-1.586-1.722,4.482,4.482,0,0,1-.3-3.452l19.524-62a4.692,4.692,0,0,1,2.226-2.656,4.536,4.536,0,0,1,1.459-.467,4.653,4.653,0,0,1,1.322,0h0A75.925,75.925,0,0,1,289.39,98.478c.037.019.078.044.122.07a4.6,4.6,0,0,1,1.247,1.064,4.19,4.19,0,0,1,.5.753,4.716,4.716,0,0,1,.3,3.454l-19.527,62a4.747,4.747,0,0,1-2.227,2.659Z",
    transform: "translate(-199.457 -86.588)",
    fill: "#e9f0fa"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12986",
    "data-name": "Path 12986",
    d: "M282.536,157.367c-1.107.026-2.134.094-3.067.181a3.717,3.717,0,0,0-1.994.554,4.708,4.708,0,0,0-1.493,1.452,5.219,5.219,0,0,0-.593,1.222l-.744,2.188a40.275,40.275,0,0,1-22.37-5.571,41.772,41.772,0,0,1-4.128-2.783l.644-2.65a5.26,5.26,0,0,0,.152-1.35,4.7,4.7,0,0,0-.481-2.026,3.673,3.673,0,0,0-1.387-1.536c-.646-.5-1.364-1.031-2.151-1.569l18.5-58.754,0,0A75.881,75.881,0,0,1,298.329,97c.921.534,1.779,1.061,2.578,1.57.037.019.078.044.122.07l-18.494,58.73Z",
    transform: "translate(-210.975 -86.678)",
    fill: "#353f44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    width: 21.722,
    height: 15.272,
    rx: 4,
    transform: "translate(38.504 55.304) rotate(-72.182)",
    fill: "url(#linear-gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_994",
    "data-name": "Rectangle 994",
    width: 12.829,
    height: 14.299,
    rx: 4,
    transform: "translate(55.938 60.24) rotate(-72.182)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12987",
    "data-name": "Path 12987",
    d: "M299.828,192.5a4.594,4.594,0,0,1-2.321.507,56.94,56.94,0,0,1-22.759-3.394q-.658-.241-1.289-.492c10.455,1.608,18.284,2.171,21.444,1.685a7.067,7.067,0,0,0,4.016-1.771,6.876,6.876,0,0,0,1.908-3.8q7.962-24.8,16.024-49.563,1.958-6.024,3.928-12.043a4.2,4.2,0,0,1,.5.753,4.716,4.716,0,0,1,.3,3.454l-19.527,62a4.746,4.746,0,0,1-2.227,2.659Z",
    transform: "translate(-229.478 -110.61)",
    fill: "#232952",
    opacity: 0.24,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12988",
    "data-name": "Path 12988",
    d: "M296.095,176.312c-1.107.026-2.134.094-3.067.181a3.717,3.717,0,0,0-1.994.554,4.708,4.708,0,0,0-1.493,1.452,5.218,5.218,0,0,0-.593,1.222l-.744,2.188a40.275,40.275,0,0,1-22.37-5.571,86.772,86.772,0,0,0,16.677.732,15,15,0,0,0,2.559-.245c8.513-1.882,11.764-14.088,17.769-33.264,2.016-6.435,5.051-15.914,9.048-27.618.921.534,1.779,1.061,2.578,1.57.037.019.078.044.122.07l-18.494,58.73Z",
    transform: "translate(-224.533 -105.623)",
    fill: "#15192f",
    opacity: 0.24,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12989",
    "data-name": "Path 12989",
    d: "M261.155,135.483,274.68,93.9a52.255,52.255,0,0,1,5.449.3,53.5,53.5,0,0,1,16.606,4.611c-2.344-.294-5.827-.663-10.109-.853-3.916-.174-4.768-.032-5.346.114-4.952,1.248-7.428,7.269-8.942,10.92-3.377,8.141-7.013,16.656-11.183,26.5Z",
    transform: "translate(-221.498 -91.327)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12990",
    "data-name": "Path 12990",
    d: "M230.847,158.221c-.561-.414-1.092-.816-1.583-1.2a4.572,4.572,0,0,1-1.586-1.722,4.482,4.482,0,0,1-.3-3.452L246.9,89.838a4.693,4.693,0,0,1,2.226-2.656,4.535,4.535,0,0,1,1.459-.467c-.565.9-1.2,1.97-1.836,3.2a45.124,45.124,0,0,0-2.965,7.128c-3.917,12.114-5.876,18.175-8.422,26.167-2.71,8.511-4.448,17.337-7.577,25.7a9.9,9.9,0,0,0-.661,3.166,11.132,11.132,0,0,0,1.722,6.138Z",
    transform: "translate(-199.457 -86.671)",
    fill: "#fff",
    opacity: 0.49,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12991",
    "data-name": "Path 12991",
    d: "M265.386,370.838a2.194,2.194,0,0,1-1.412-2.67,2.188,2.188,0,0,1,1.093-1.363,2.137,2.137,0,0,1,1.2-.175,3.463,3.463,0,0,1,2.268,1.454c.239.323.534.836.6.957.213.372.278.527.4.746a3.962,3.962,0,0,0,1.312,1.616,2.361,2.361,0,0,0,1.681.362,2.309,2.309,0,0,0,1.44-.964,2.143,2.143,0,0,0,.406-1.446,2.035,2.035,0,0,0-.313-.858,2.264,2.264,0,0,0-.75-.743,2.857,2.857,0,0,0-2.517.034,5.091,5.091,0,0,0-.747.431l-.074.054a5.727,5.727,0,0,0-.836.769c-.295.317-.352.428-.539.64a3.614,3.614,0,0,1-1.677,1.154,2.439,2.439,0,0,1-1.533,0Z",
    transform: "translate(-223.277 -268.169)",
    fill: "none",
    stroke: "#139093",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12358",
    "data-name": "Group 12358",
    transform: "translate(169.431 9.283)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12992",
    "data-name": "Path 12992",
    d: "M256.547,82.377c0,4.842-.151,16.439-.253,17.5s-1.392.927-1.391-1.083-1.192-14.2-1.193-16.861S256.547,75.781,256.547,82.377Z",
    transform: "translate(-237.751 -54.227)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12357",
    "data-name": "Group 12357",
    transform: "translate(0)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12993",
    "data-name": "Path 12993",
    d: "M275.707,28.488l-33.664-18.9a2.6,2.6,0,0,0-2.939.342L209.2,37.569a2.6,2.6,0,0,0,1.422,4.538l23.51,1.793c2.533-1.732,7.218-3.317,12.718-4.1a39.43,39.43,0,0,1,10.763-.206l17.84-6.392A2.6,2.6,0,0,0,275.707,28.488Z",
    transform: "translate(-208.314 -9.283)",
    fill: "url(#linear-gradient-5)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12994",
    "data-name": "Path 12994",
    d: "M276.035,31.863l-33.27-17.707a2.6,2.6,0,0,0-2.939.343L209.8,40.895a2.6,2.6,0,0,0,1.422,4.538l22.022,2.516c1.905-2.132,7.359-4.241,14-5.191,5.1-.731,9.725-.6,12.7.178l15.847-6.363A2.6,2.6,0,0,0,276.035,31.863Z",
    transform: "translate(-208.701 -12.245)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12995",
    "data-name": "Path 12995",
    d: "M211.318,40.895l30.028-26.4a2.6,2.6,0,0,1,2.939-.343l33.27,17.707c1.952,1.039-32.793-12.431-32.793-12.431a2.6,2.6,0,0,0-2.939.342S209.645,42.365,211.318,40.895Z",
    transform: "translate(-210.221 -12.245)",
    opacity: 0.2,
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12996",
    "data-name": "Path 12996",
    d: "M280.4,71.638c8.239-1.179,15.234-.136,16.011,2.322l2.2-.315-3.2-9.282-.023,0c-.888-2.945-9.57-7.069-19.051-5.712-9.775,1.4-16.712,7.912-16.263,11.053a1.975,1.975,0,0,0,.224.643l2.915,8.362,2.472-.354C265.742,75.781,272.163,72.817,280.4,71.638Z",
    transform: "translate(-241.865 -41.125)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12997",
    "data-name": "Path 12997",
    d: "M276.338,58.654c9.481-1.357,18.163,2.768,19.051,5.712l.023,0,3.2,9.282-.116.017-2.144-6.219-.022,0c-.888-2.944-9.57-7.069-19.051-5.712-9.4,1.346-16.159,7.415-16.262,10.671L260.3,70.35a1.968,1.968,0,0,1-.224-.643C259.625,66.566,266.563,60.053,276.338,58.654Z",
    transform: "translate(-241.865 -41.125)",
    opacity: 0.3,
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12998",
    "data-name": "Path 12998",
    d: "M271.052,102.23l.571-1.815a1.577,1.577,0,0,1-.149-.476c-.248-1.733,2.531-3.674,6.878-5.148.1-.034.2-.068.3-.1.219-.072.442-.142.668-.212q.265-.081.537-.16c.2-.057.392-.115.594-.17q.5-.138,1.023-.266c.144-.036.29-.07.437-.1.334-.079.673-.156,1.017-.229.151-.032.3-.063.456-.094q.48-.1.972-.186c.142-.026.283-.052.426-.077.467-.08.938-.157,1.417-.225q.786-.112,1.554-.2c.183-.02.361-.034.543-.052.324-.033.65-.067.969-.092.231-.018.455-.03.683-.044.261-.017.525-.037.781-.049s.5-.017.754-.025c.218-.007.439-.016.653-.019.276,0,.542,0,.811,0,.177,0,.357,0,.531,0,.291.006.572.019.854.032.138.006.281.01.417.018.3.018.594.042.884.068.1.009.207.016.308.026.308.031.6.069.894.109.055.008.115.013.169.021l.076.012q.2.029.386.061l.239.038.058.018a10.255,10.255,0,0,1,3.209,1.056q1.794.634,3.456,1.316a1.862,1.862,0,0,0-.019-.29c-.45-3.141-8.738-4.553-18.513-3.154s-17.334,5.08-16.885,8.221C269.131,100.912,269.859,101.649,271.052,102.23Z",
    transform: "translate(-247.658 -62.455)",
    fill: "url(#linear-gradient-10)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12999",
    "data-name": "Path 12999",
    d: "M253.069,132.938a6.306,6.306,0,0,0-.242,2.734,4.914,4.914,0,0,1-1.409-1.689,8.31,8.31,0,0,1,.221-2.778,5.911,5.911,0,0,0-.528,2.122,16.749,16.749,0,0,1-1.288-8.6c.359-2.787,1.393-5.116,3.676-3.466,4.812,3.478,1.642,8.014,1.37,10.844-.038.394-.061.755-.077,1.1a8.314,8.314,0,0,1-1.389-2.425,6.989,6.989,0,0,0,1.369,3.065c-.008.5,0,.918.026,1.273a7.542,7.542,0,0,1-.638-1.356,5.371,5.371,0,0,0,.683,1.925,7.2,7.2,0,0,0,.109.735,3.612,3.612,0,0,1-1.708-.483A8.326,8.326,0,0,1,253.069,132.938Z",
    transform: "translate(-235.155 -81.542)",
    fill: "url(#linear-gradient-11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityStudent);
export default __webpack_public_path__ + "static/media/infinity-student.346d350806e1c8b0985327951d015c6d.svg";
export { ForwardRef as ReactComponent };